import React, { useState, useContext } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LinearProgress, Accordion, AccordionSummary, Typography, Grid } from '@mui/material';

import IdentifiedSpeciesRow from './IdentifiedSpeciesRow';
import { identifiedSpeciesIsVirus } from './utilities';
import { IdentifiedSpeciesFiltersContext } from '../context/IdentifiedSpeciesFiltersContext';

export const IdentifiedSpeciesDisplaySummary = ({
  identifiedSpecies,
  displayingSpeciesCt,
  isViral,
}) => {
  const { showKIDCalls } = useContext(IdentifiedSpeciesFiltersContext);

  const getSpeciesStats = (species) => {
    if (!species) return { positive: 0, subthreshold: 0 };
    return {
      positive: species.filter(item => item.attributes.species_call_positive).length,
      subthreshold: species.filter(item => !item.attributes.species_call_positive).length
    };
  };

  const { positive, subthreshold } = getSpeciesStats(identifiedSpecies);

  return <Typography component="span">
      <small>
      Displaying data for <b>{displayingSpeciesCt}</b> of <b>{identifiedSpecies?.length}</b>
      {isViral ? ' viral': ' total'} 
      {(showKIDCalls && identifiedSpecies) ? ` (${positive} positive; ${subthreshold} subthreshold) ` : ' '}
      organisms
      </small>
    </Typography>
}

export const IdentifiedSpeciesContent = ({
    loading,
    identifiedSpecies,
    isDiagnosticView,
    visibleSpeciesCt,
    isIllumina,
    totalMicrobialMegabases,
}) => {
  if (loading || !identifiedSpecies) return <LinearProgress />;
  return identifiedSpecies
    .filter(item => !isDiagnosticView || item.attributes.species_call_positive)
    .slice(0, isDiagnosticView ? 5 : visibleSpeciesCt)
    .filter(item => !identifiedSpeciesIsVirus(item))
    .map((item, index) => (
      <IdentifiedSpeciesRow
        key={index}
        identifiedSpecies={item}
        isIllumina={isIllumina}
        isDiagnosticView={isDiagnosticView}
        totalMicrobialMegabases={totalMicrobialMegabases}
      />
    ));
};

export const IdentifiedVirusContent = ({
  loading,
  identifiedSpecies,
  isDiagnosticView,
  visibleSpeciesCt,
  isIllumina,
  totalMicrobialMegabases,
}) => {
  const [ expanded, setExpanded ] = useState(false);
  const handleAccordionChange = () => {setExpanded((prev) => !prev)};

  const viralIdentifiedSpecies = identifiedSpecies?.filter(item => identifiedSpeciesIsVirus(item));

  if (loading || !identifiedSpecies || !viralIdentifiedSpecies.length) return <></>;

  const visibleViralIdentifiedSpecies = identifiedSpecies
    .slice(0, isDiagnosticView ? 5 : visibleSpeciesCt)
    .filter(item => identifiedSpeciesIsVirus(item));

  return <Accordion disableGutters expanded={expanded} onChange={handleAccordionChange}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="viral-identified-species-content"
      id="viral-identified-species-header"
      sx={{ backgroundColor: '#eee', padding: '1px 10px' }}
    >
      <Grid container spacing={2}>
        <Grid item xs={2.5}>
          <Typography component="span">
            <b>{viralIdentifiedSpecies.length}</b> viruses identified
          </Typography>
        </Grid>
        {
          expanded &&
          <Grid item xs={6}>
            <IdentifiedSpeciesDisplaySummary
              identifiedSpecies={viralIdentifiedSpecies}
              displayingSpeciesCt={visibleViralIdentifiedSpecies.length}
              isViral
            />
          </Grid>
        }
      </Grid>
    </AccordionSummary>
      {visibleViralIdentifiedSpecies.map((item, index) => (
        <IdentifiedSpeciesRow
          key={index}
          identifiedSpecies={item}
          isIllumina={isIllumina}
          isDiagnosticView={isDiagnosticView}
          totalMicrobialMegabases={totalMicrobialMegabases}
        />
      ))}
  </Accordion>
}
